module.exports = __webpack_public_path__ + "img/games-14.da059231.jpg";